export const DEFAULT_THEME_COLORS = {
  '--theme-color__brand-primary': '#425CCD',
  /**
   * The default brand secondary was designed to match the default brand primary "lightest".
   * This color was generated per the formula in ComputedUserTheme.tsx.
   *
   * TODO create ticket to migrate existing campaigns (original color was #E8EBF9)
   */
  '--theme-color__brand-secondary': '#E0E5F7',
  '--theme-color__brand-tertiary': '#303030',
  '--theme-color__text-general': '#2D2E31',
  '--theme-color__background': '#FFFFFF',
  '--theme-color__background-accent': '#F2F1EF'
};
export const DEFAULT_THEME = {
  ...DEFAULT_THEME_COLORS,
  '--theme-font__font-family--general': 'var(--classy-font__font-family--base)',
  '--theme-font__font-family--paragraph': 'var(--classy-font__font-family--base)',
  '--theme-font__font-family--heading': 'var(--classy-font__font-family--base)',
  '--theme-font__label--font-size': '12px',
  '--theme-font__label--line-height': '1.5',
  '--theme-font__label--font-weight': '400',
  '--theme-font__paragraph-md--font-size': '16px',
  '--theme-font__paragraph-md--line-height': '1.5',
  '--theme-font__paragraph-md--font-weight': '400',
  '--theme-font__paragraph-lg--font-size': '20px',
  '--theme-font__paragraph-lg--line-height': '1.5',
  '--theme-font__paragraph-lg--font-weight': '400',
  '--theme-font__heading-sm--font-size': '28px',
  '--theme-font__heading-sm--line-height': '1.2',
  '--theme-font__heading-sm--font-weight': '700',
  '--theme-font__heading-md--font-size': '32px',
  '--theme-font__heading-md--line-height': '1.2',
  '--theme-font__heading-md--font-weight': '700',
  '--theme-font__heading-lg--font-size': '40px',
  '--theme-font__heading-lg--line-height': '1.2',
  '--theme-font__heading-lg--font-weight': '700',
  '--theme-font__heading-xl--font-size': '48px',
  '--theme-font__heading-xl--line-height': '1.2',
  '--theme-font__heading-xl--font-weight': '700'
};